var render = function render(){var _vm=this,_c=_vm._self._c;return _c('custom-modal',{attrs:{"width":"90%","title":"查看申请资料","footer":null,"visible":_vm.visible},on:{"on-close":() => _vm.$emit('on-close')}},[_c('modal-content',{attrs:{"handling-info-tpl":_vm.handlingInfoTpl,"special-bank-account-info":_vm.specialBankAccountInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }